import { ReactElement } from "react";
import { useElementContext } from "@ultracommerce/react-storefront/global";
import { MenuItemProps } from "@ultracommerce/react-storefront/global/src/components/Header/MenuItem/MenuItem";

export interface ContentStackMenuProps {
  contentStack: ReactElement[];
}

const ContentStackMenu = ({ contentStack }: ContentStackMenuProps) => {
  const {
    CommonModule: { MenuItem },
  } = useElementContext();
  return (
    <>
      {contentStack?.map((contentStac, i) => {
        return (
          <ul className="col-12" key={i}>
            {contentStac?.props?.el?.innerElements?.length > 0 && (
              <>
                <>
                  <ul className="d-flex gap-3 justify-content-between flex-wrap px-2">
                    {contentStac.props.el.innerElements.map((d: MenuItemProps, i: number) => {
                      return <MenuItem {...d} key={i} cssClass={`px-0 py-0 ${d.cssClass}`} />;
                    })}
                  </ul>
                </>
              </>
            )}
          </ul>
        );
      })}
    </>
  );
};

export { ContentStackMenu };
